import { Box } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ConnectionOptionsSideBanner from "../ConnectionOptionsSideBanner/ConnectionOptionsSideBanner";
import useHandleAnchorClick from "../../hooks/useHandleAnchorClick";
import "./directIntegrationTab.scss";
import { useTranslation } from "react-i18next";

const DirectIntegrationTab = ({ jsonData }) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const handleAnchorClick = useHandleAnchorClick();

  useEffect(() => {
    let button = document.querySelector("#gettingStartedbtn");
    button?.addEventListener("click", () => window.location.href = `/${i18n.language}/api/gettingstarted/gettingstarted`)
    return () => {
      button?.removeEventListener("click", () => navigate(`/${i18n.language}/api/gettingstarted/gettingstarted`));
    }
    // eslint-disable-next-line
  }, [])

  return (
    <Box className="directIntgContainer">
      <Box className="directIntgContent">
        <Box dangerouslySetInnerHTML={{ __html: jsonData["direct-integration"] }} onClick={handleAnchorClick} />
      </Box>
      <Box>
        <ConnectionOptionsSideBanner data={jsonData["direct-integration-banner"]} />
      </Box>
    </Box>
  );
};

export default DirectIntegrationTab;
